import * as z from 'zod';
import { isValidPhoneNumber, parsePhoneNumberWithError } from 'libphonenumber-js';

export const phoneNumberSchema = z
  .string()
  .min(1, { message: 'Phone number is required' })
  .refine(isValidPhoneNumber, 'Please specify a valid phone number (include the international prefix).')
  .transform((value) => parsePhoneNumberWithError(value).number.toString());
